import {
  GameSetting,
  IServices,
  MoneyType as OriginMoneyType
} from "@netent/origin";
import { IGameSetting } from "@netent/playui";
import { PlayUIListenerCreator } from "../../types";

export const onSettingChangeRequest: PlayUIListenerCreator = (
  services: IServices
) => ({ key, value }: IGameSetting) => {
  // isCash is not treated as a regular game setting
  // instead uses the Money service to get and set
  if (key === "isCash") {
    const moneyType: OriginMoneyType = value === true ? "cash" : "coins";
    services.money.setType(moneyType);
  } else {
    services.gameSettings.setSetting({
      id: key as GameSetting,
      persistent: true,
      value
    });
  }
};
